const routes = [
    {
        path: '/contabilidade/alterdata_sistemas/fiscal/:hash',
        alias: ['/contabilidade/alterdata_sistemas/fiscal/index/:hash'],
        component: () => import('../views/Listar'),
    }
]

export default routes
